import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import { applyStyles } from 'util/helpers';
import Image from 'components/common/Image';

import imgTopMain1PC1x from 'assets/images/PC/@1x/img_top_main1.jpg';
import imgTopMain1PC2x from 'assets/images/PC/@2x/img_top_main1@2x.jpg';
import imgTopMain1SP2x from 'assets/images/SP/@2x/img_top_main1@2x.jpg';
import imgTopMain1SP3x from 'assets/images/SP/@3x/img_top_main1@3x.jpg';
import imgTopMain1WebpPC1x from 'assets/images/PC/@1x/img_top_main1.webp';
import imgTopMain1WebpPC2x from 'assets/images/PC/@2x/img_top_main1@2x.webp';
import imgTopMain1WebpSP2x from 'assets/images/SP/@2x/img_top_main1@2x.webp';
import imgTopMain1WebpSP3x from 'assets/images/SP/@3x/img_top_main1@3x.webp';

import imgTitle1PC1x from 'assets/images/PC/@1x/img_title1.png';
import imgTitle1PC2x from 'assets/images/PC/@2x/img_title1@2x.png';
import imgTitle1SP2x from 'assets/images/SP/@2x/img_title1@2x.png';
import imgTitle1SP3x from 'assets/images/SP/@3x/img_title1@3x.png';
import imgTitle2PC1x from 'assets/images/PC/@1x/img_title2.png';
import imgTitle2PC2x from 'assets/images/PC/@2x/img_title2@2x.png';
import imgTitle2SP2x from 'assets/images/SP/@2x/img_title2@2x.png';
import imgTitle2SP3x from 'assets/images/SP/@3x/img_title2@3x.png';

import imgTopGiftPC1x from 'assets/images/PC/@1x/img_top_gift.png';
import imgTopGiftPC2x from 'assets/images/PC/@2x/img_top_gift@2x.png';
import imgTopGiftSP2x from 'assets/images/SP/@2x/img_top_gift@2x.png';
import imgTopGiftSP3x from 'assets/images/SP/@3x/img_top_gift@3x.png';

class ImageSlide extends React.Component {
  render() {
    const { className } = this.props;

    return (
      <div className={className}>
        <Image
          className="image-main"
          pc1x={imgTopMain1PC1x}
          pc2x={imgTopMain1PC2x}
          sp2x={imgTopMain1SP2x}
          sp3x={imgTopMain1SP3x}
          webpPC1x={imgTopMain1WebpPC1x}
          webpPC2x={imgTopMain1WebpPC2x}
          webpSP2x={imgTopMain1WebpSP2x}
          webpSP3x={imgTopMain1WebpSP3x}
          alt="img_top_main1"
        />

        <div className="title">
          <div className="image-title-wrapper title1">
            <Image
              pc1x={imgTitle1PC1x}
              pc2x={imgTitle1PC2x}
              sp2x={imgTitle1SP2x}
              sp3x={imgTitle1SP3x}
              alt="img_title1"
            />
          </div>
          <div className="image-title-wrapper title2">
            <Image
              pc1x={imgTitle2PC1x}
              pc2x={imgTitle2PC2x}
              sp2x={imgTitle2SP2x}
              sp3x={imgTitle2SP3x}
              alt="img_title2"
            />
          </div>
        </div>
        <div className="gift">
          <Image
            pc1x={imgTopGiftPC1x}
            pc2x={imgTopGiftPC2x}
            sp2x={imgTopGiftSP2x}
            sp3x={imgTopGiftSP3x}
            alt="img_top_gift"
          />
        </div>
      </div>
    );
  }
}

const commonStyle = css`
  overflow: hidden;
  margin-right: 80px;
  position: relative;

  .image-main {
    width: 100%;
    object-fit: cover;
  }

  .title {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    flex-direction: row-reverse;
  }

  .image-title-wrapper {
    height: 0;
    overflow: hidden;
    animation-name: title-slide-in;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-timing-function: ease-out;
    animation-iteration-count: 1;

    &.title1 {
      animation-delay: 0.5s;
    }

    &.title2 {
      animation-delay: 1.25s;
    }
  }

  .gift {
    position: absolute;
    opacity: 0;
    transform: translateY(-10px);
    animation-name: gift-slide-in;
    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-timing-function: ease-out;
    animation-iteration-count: 1;
    animation-delay: 2.02s;
  }

  @keyframes title-slide-in {
    from {
      height: 0;
    }

    to {
      height: 100%;
    }
  }

  @keyframes gift-slide-in {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  height: 658px;
  margin-bottom: 48px;

  .image-main {
    height: 658px;
  }

  .title {
    height: 432px;
  }

  .gift {
    bottom: 32px;
    left: 5%;
  }

  .indicator {
    position: absolute;
    bottom: 32px;
    left: 40px;
    width: 100%;
    display: flex;
    justify-content: center;
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  margin-right: 16px;
  height: 420px;
  margin-bottom: 36px;

  .image-main {
    height: 420px;

    picture {
      width: 100%;
    }
  }

  .title {
    height: 262px;
  }

  .gift {
    bottom: 16px;
    left: 16px;
  }
`;

export default applyStyles(ImageSlide)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/Home/components/ImageSlide.js